import { patchCurrentUser } from '../../api/me';

let activityIntervalId = null;
let activityListenersAttached = false;
let trackedUserId = null;
let lastWriteEpochMs = 0;

const MIN_WRITE_INTERVAL_MS = 60 * 1000;
const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;

const safeNow = () => Date.now();

const shouldWrite = () => {
  const now = safeNow();
  return now - lastWriteEpochMs >= MIN_WRITE_INTERVAL_MS;
};

const writeActivity = async () => {
  if (!trackedUserId) return;
  try {
    await patchCurrentUser({
      lastActiveAt: new Date().toISOString(),
      lastActiveSource: 'web',
    });
    lastWriteEpochMs = safeNow();
  } catch {
    // Swallow errors to avoid impacting UX
  }
};

const handleUserActivity = () => {
  if (shouldWrite()) {
    void writeActivity();
  }
};

const attachActivityListeners = () => {
  if (activityListenersAttached) return;
  activityListenersAttached = true;

  window.addEventListener('focus', handleUserActivity);
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      handleUserActivity();
    }
  });
  window.addEventListener('mousemove', handleUserActivity);
  window.addEventListener('keydown', handleUserActivity);
  window.addEventListener('touchstart', handleUserActivity, { passive: true });
};

const detachActivityListeners = () => {
  if (!activityListenersAttached) return;
  activityListenersAttached = false;

  window.removeEventListener('focus', handleUserActivity);
  window.removeEventListener('visibilitychange', handleUserActivity);
  window.removeEventListener('mousemove', handleUserActivity);
  window.removeEventListener('keydown', handleUserActivity);
  window.removeEventListener('touchstart', handleUserActivity);
};

export const startUserActivityTracking = (userId) => {
  try {
    if (!userId) return;

    trackedUserId = userId;
    attachActivityListeners();
    void writeActivity();

    if (!activityIntervalId) {
      activityIntervalId = setInterval(() => {
        if (document.visibilityState === 'visible') {
          void writeActivity();
        }
      }, HEARTBEAT_INTERVAL_MS);
    }
  } catch {
    // noop
  }
};

export const stopUserActivityTracking = () => {
  try {
    if (activityIntervalId) {
      clearInterval(activityIntervalId);
      activityIntervalId = null;
    }
    detachActivityListeners();
  } catch {
    // noop
  } finally {
    trackedUserId = null;
    lastWriteEpochMs = 0;
  }
};
